import { OrcaPropTypes } from "./constants";

export const getOrcaProps = element => {
  const props = {};

  OrcaPropTypes.forEach(prop => {
    if (element.hasAttribute(prop.name)) {
      if (prop.type === "object") {
        props[prop.name] = JSON.parse(element.getAttribute(prop.name));
      } else {
        props[prop.name] = element.getAttribute(prop.name);
      }
    }
  });

  return props;
};
